import React, { useEffect } from 'react';
import { ERROR_WRONG_PHONE_TYPE, NON_DIGITS_REG_EXP } from '../constant';
import { DangerIcon } from '../appearence/icons/danger_icon';
import { useTranslation } from 'react-i18next';
import { cn } from '@chapche/ui';

const PhoneInput = ({ phone, setPhoneInput, error }) => {
    const { i18n } = useTranslation();
    const changePhoneAppearence = (event, cleanAll) => {
        if(cleanAll) {
            document.getElementsByClassName('login__input-phone')[0].value = '';
            return;
        }
        if (!(event.key == 'ArrowLeft' || event.key == 'ArrowRight' || event.key == 'Backspace' || event.key == 'Tab')) { 
            event.preventDefault();
        }
        if(event.key == 'Backspace') {
            setPhoneInput(event.target.value.slice(0, -1).replace(NON_DIGITS_REG_EXP, ''));
        } 
        if(isFinite(+event.key)) {
            setPhoneInput((event.target.value + event.key).replace(NON_DIGITS_REG_EXP, ''));
        }
        const mask = '(111) 111 11 11';
        if (/[0-9\+\ \(\)]/.test(event.key)) {
            let currentString = event.target.value;
            const currentLength = currentString.length;
            if (/[0-9]/.test(event.key)) {
                if (mask[currentLength] == '1') {
                    event.target.value = currentString + event.key;
                } else {
                    for (var i = currentLength; i < mask.length; i++) {
                        if (mask[i] == '1') {
                            event.target.value = currentString + event.key;
                            break;
                        }
                        currentString += mask[i];
                    }
                }
            }
        }
    };

    useEffect(() => {
        if(phone === '') {
            changePhoneAppearence({}, true);
        }
    }, [phone]);

    return (
        <label className="block__text login__label">
            <p className="input__label">{i18n.t("public.app.page.login.phone")}</p>
            <div className="login__phone flex items-center gap-8">
                <div className="block__content">+7</div>
                <div className="input__wrapper login__input-phone flex-1">
                    <input
                        className={cn(
                            'block__content input input__content box-border w-full max-w-none rounded-input border border-solid border-light-grey bg-white px-16 py-12 font-montserrat-medium text-l text-ink',
                            'placeholder:text-secondary-light-grey',
                            error.type === ERROR_WRONG_PHONE_TYPE && 'input_error login__input_error border-error',
                        )}
                        onKeyDown={changePhoneAppearence}
                        placeholder='(___) ___ __ __'
                        defaultValue={setPhoneInput ? '' : phone}
                        disabled={setPhoneInput ? false : true} />
                    {error.type === ERROR_WRONG_PHONE_TYPE ? <DangerIcon nameOfClass="input__icon login__icon-danger"/> : ''}
                </div>
            </div>
        </label>
    );
};

export default PhoneInput;
